import axios from 'axios';
import { getAPIURL } from '../common/utils';
import { currentUserToken, renewOrSignOut } from '../common/auth';
import { OCL_CLIENT } from '../common/constants';


// Trimmed port of oclmap's API client — the community site only talks to
// the OCL API for the OIDC code exchange, the user profile cache and the
// public events feed.
const baseHeaders = { 'X-OCL-CLIENT': OCL_CLIENT };

const authHeaders = () => {
  const token = currentUserToken();
  return {
    ...baseHeaders,
    ...(token ? { Authorization: `Token ${token}` } : {}),
  };
};

const onError = (error) => error.response || { status: 0, data: null, headers: {} };

// 401 only: a 403 is a permission error, not an expired session.
const tokenRefused = (response) => response.status === 401 && Boolean(currentUserToken());

const CODE_EXCHANGE_PATH = '/users/oidc/code-exchange/';

const postWithoutToken = (data) =>
  axios.post(`${getAPIURL()}${CODE_EXCHANGE_PATH}`, data, { headers: baseHeaders });

const handleRefusal = (response) => {
  if (tokenRefused(response))
    renewOrSignOut();
  return response;
};

const APIService = {
  get: (path, params = {}, extraHeaders = {}) =>
    axios.get(`${getAPIURL()}${path}`, { headers: { ...authHeaders(), ...extraHeaders }, params }).catch(onError).then(handleRefusal),
  // Never sends the user's token. For endpoints whose response changes when
  // authenticated, where the page wants the public view regardless — e.g.
  // /events/ 303s signed-in callers to their own feed.
  getPublic: (path, params = {}) =>
    axios.get(`${getAPIURL()}${path}`, { headers: baseHeaders, params }).catch(onError),
  // The code exchange starts or renews a session, so it never carries the token.
  post: (path, data) => path === CODE_EXCHANGE_PATH ?
    postWithoutToken(data).catch(onError) :
    axios.post(`${getAPIURL()}${path}`, data, { headers: authHeaders() }).catch(onError).then(handleRefusal),
};

export default APIService;
